'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/react-is/index.js
// module id = ./node_modules/recharts/node_modules/react-is/index.js
// module chunks = 1